<template>
  <!-- + Properties ListMap -->
  <div class="container-fluid" data-file="PropertiesSearchMainMap">
    <div
      v-if="showMobilePropertyTypeFiltersOnlyMode"
      class="row tw-justify-center"
    >
      <div
        class="tw-flex tw-w-full tw-items-center tw-gap-4 tw-px-[18px] tw-pb-[8px] tw-pt-[18px] max-[350px]:tw-gap-2 md:tw-hidden"
      >
        <SearchNavSubMenu
          v-if="housemateGroupsEnabled"
          :enable-housemate-groups="housemateGroupsEnabled"
          :is-logged-in-student="isLoggedInStudent"
          :has-enquired-properties="hasEnquiredProperties"
          :shortlist-active="shortlistActive"
          :show-housemate-group-tab="showHousemateGroupTab"
          :housemate-group-active="housemateGroupsActive"
          :user-enquiries-active="userEnquiriesActive"
          class="tw-block md:tw-hidden"
          @toggle-short-list="toggleShortList"
          @toggle-housemate-group="toggleHousemateGroup"
          @toggle-user-enquiry="toggleUserEnquiry"
        />

        <PropertyTypeFiltersTrigger
          v-if="enablePropertyTypeFilters && showSortControls"
          :expanded="propertyTypeFiltersExpanded"
          :disabled="isSortDisabledOnMobile"
          class="tw-w-[188px] tw-shrink-0 md:tw-hidden"
          @toggle="propertyTypeFiltersExpanded = !propertyTypeFiltersExpanded"
        />
        <div
          v-else-if="showSortControls"
          class="custom-select-wrapper-bw tw-flex tw-flex-1 md:tw-hidden"
          data-uh="sort-by"
          data-label="properties-search-main-backup-2024-0"
        >
          <div class="custom-select noSelect tw-w-full tw-border-none">
            <button
              v-if="!isSortDisabledOnMobile"
              type="button"
              :class="[
                'tw-flex tw-h-[44px] tw-w-full tw-cursor-pointer tw-touch-manipulation tw-flex-row tw-content-evenly tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[100px] tw-border-[1px] tw-border-[#D1D5DB] tw-bg-white !tw-px-[10px] tw-text-[16px] tw-leading-[32px] tw-text-[#5C6A75] hover:tw-text-black focus:tw-text-black',
                {
                  disabled: reloading,
                },
              ]"
            >
              <span class="arrow-off">
                <i
                  class="fas sort-by-search font-size-20px sort tw-ml-1 tw-pt-[7px]"
                ></i>
              </span>
              <span
                class="d-md-none tw-inline-block tw-max-w-[120px] tw-overflow-hidden tw-truncate tw-text-ellipsis tw-whitespace-nowrap tw-text-[14px] tw-font-semibold tw-leading-[21px] tw-text-primary-grey"
                :title="displayedCurrentSortTitleShort"
              >
                {{ displayedCurrentSortTitleShort }}
              </span>
            </button>
            <div
              v-else
              class="tw-flex tw-h-[44px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[30px] tw-bg-[#9CA3AF] tw-px-[24px] tw-py-[8px]"
            >
              <SortButtonDisabled />
              <span
                class="tw-font-inter tw-text-center tw-text-[14px] tw-font-semibold tw-leading-[150%] tw-text-white"
              >
                Relevance
              </span>
            </div>
            <div
              class="custom-options tw-left-[-200px] tw-z-20 tw-rounded-[16px] tw-p-0 tw-drop-shadow-md md:tw-left-[-120px]"
              data-uh="sort-by-results"
            >
              <span
                v-for="(value, key, index) in displayedSortOptions"
                :key="index"
                class="custom-option transition-all duration-300 ease-in-out tw-m-0 tw-px-[24px] tw-py-[16px]"
                :class="{
                  selected: activeSortKey === key,
                  'tw-border-t-[1px] tw-border-[#E5E7EB]': index !== 0,
                }"
                :data-uh="`sort-by-${key}`"
                @click="handleSortChange(key)"
              >
                {{ value.full }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <PropertyTypeFiltersExtension
        v-if="enablePropertyTypeFilters && showSortControls"
        class="md:tw-hidden"
        :active="currentType"
        :expanded="propertyTypeFiltersExpanded"
        :enable-private-halls-filter="enablePrivateHallsFilter"
        :enable-spare-room-functionality="enableSpareRoomFunctionality"
        :disabled="isSortDisabledOnMobile"
        :show-mobile-trigger="false"
        @update:expanded="propertyTypeFiltersExpanded = $event"
        @change="$emit('set-current-type', $event)"
      />
    </div>

    <!-- + Mobile Filter only -->
    <div
      v-if="!showMobilePropertyTypeFiltersOnlyMode"
      v-show="!mapIsOpen"
      data-component="sorting-and-map-button"
      :class="[
        'row tw-items-center tw-justify-center',
        { 'tw-flex md:tw-hidden': !mapIsOpen },
      ]"
    >
      <div
        class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-[16px] md:tw-hidden"
      >
        <!-- TODO remove this before go live. Leaving this commented out during development-->
        <!-- Map Button -->
        <!--        <button-->
        <!--          v-if="propertiesData.length && canShowMapView"-->
        <!--          id="show_map"-->
        <!--          ref="showMap"-->
        <!--          data-testid="show-new-map"-->
        <!--          class="tw-flex tw-h-[40px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[31px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-text-[14px] tw-leading-[32px] tw-text-[#5C6A75] hover:tw-text-[#5C6A75] focus:tw-text-[#5C6A75]"-->
        <!--          title="Show the map"-->
        <!--          type="button"-->
        <!--          @click="toggleMap"-->
        <!--        >-->
        <!--          <i class="fas view-on-map font-size-20px tw-pr-[4px] tw-pt-[4px]" />-->
        <!--          <span-->
        <!--            class="d-md-block tw-text-[14px] tw-font-semibold tw-leading-[21px] tw-text-primary-grey"-->
        <!--          >-->
        <!--            <span class="hidden min-[405px]:inline-flex pr-[10px]">-->
        <!--              {{ mapIsOpen ? 'Close map' : 'Map view' }}-->
        <!--            </span>-->
        <!--            <span class="inline-flex min-[405px]:hidden pr-[10px]">-->
        <!--              {{ mapIsOpen ? 'Close map' : 'Map view' }}-->
        <!--            </span>-->
        <!--          </span>-->
        <!--        </button>-->

        <!-- Sort Button -->
        <!--        <div-->
        <!--          class="custom-select-wrapper-bw tw-flex tw-flex-1 md:tw-hidden"-->
        <!--          data-uh="sort-by"-->
        <!--          data-label="properties-search-main-backup-2024-0"-->
        <!--        >-->
        <!--          <div class="custom-select noSelect tw-w-full tw-border-none">-->
        <!--            &lt;!&ndash; Selected option &ndash;&gt;-->
        <!--            <div-->
        <!--              :class="[-->
        <!--                'tw-flex tw-h-[40px] tw-w-full tw-cursor-pointer tw-touch-manipulation tw-flex-row tw-content-evenly tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[100px] tw-border-[1px] tw-border-[#D1D5DB] tw-bg-white !tw-px-[10px] tw-text-[16px] tw-leading-[32px] tw-text-[#5C6A75] hover:tw-text-black focus:tw-text-black',-->
        <!--                { disabled: reloading },-->
        <!--              ]"-->
        <!--            >-->
        <!--              <div class="arrow-off">-->
        <!--                <i-->
        <!--                  class="fas sort-by-search font-size-20px sort tw-ml-1 tw-pt-[7px]"-->
        <!--                ></i>-->
        <!--              </div>-->
        <!--              <span-->
        <!--                class="d-md-none tw-inline-block tw-max-w-[120px] tw-overflow-hidden tw-truncate tw-text-ellipsis tw-whitespace-nowrap tw-text-[14px] tw-font-semibold tw-leading-[21px] tw-text-primary-grey"-->
        <!--                :title="currentSortTitleShort"-->
        <!--              >-->
        <!--                {{ currentSortTitleShort }}-->
        <!--              </span>-->
        <!--            </div>-->
        <!--            <div-->
        <!--              class="custom-options tw-left-[-200px] tw-z-20 tw-rounded-[16px] tw-p-0 tw-drop-shadow-md md:tw-left-[-120px]"-->
        <!--              data-uh="sort-by-results"-->
        <!--            >-->
        <!--              <span-->
        <!--                v-for="(value, key, index) in sortOptions"-->
        <!--                :key="index"-->
        <!--                class="custom-option transition-all duration-300 ease-in-out tw-m-0 tw-px-[24px] tw-py-[16px]"-->
        <!--                :class="{-->
        <!--                  selected: currentSort === key,-->
        <!--                  'tw-border-t-[1px] tw-border-[#E5E7EB]': index !== 0,-->
        <!--                }"-->
        <!--                :data-uh="`sort-by-${key}`"-->
        <!--                @click="$emit('set-current-sort', key)"-->
        <!--              >-->
        <!--                {{ value.full }}-->
        <!--              </span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <!-- - Sorting and Map Button Mobile -->

    <!--    Sorting and Map Button Desktop -->
    <div
      v-show="!mapIsOpen"
      ref="mapButtonContainer"
      class="row tw-justify-center"
      :class="{ 'tw-hidden md:tw-block': !mapIsOpen }"
    >
      <div
        class="container-fluid contained tw-mb-[24px] tw-flex tw-max-w-screen-xl tw-justify-between tw-p-0 lg:tw-mt-[24px] lg:tw-items-center"
      >
        <div class="tw-flex">
          <div
            class="d-none mb-0 ml-0 tw-min-w-30 tw-min-h-8 tw-w-30 tw-mr-2.5 tw-h-8 tw-self-baseline md:tw-flex lg:tw-h-auto lg:tw-flex-col-reverse"
          >
            <h3 class="tw-mb-0 tw-text-[20px] tw-leading-[28px]">
              <span
                class="tw-inline tw-font-semibold md:tw-hidden lg:tw-inline"
                dusk="desktop-title-result-count"
              >
                <template v-if="showStudentAccomodationInformation">
                  {{ title }}
                </template>

                <template v-else-if="shortlistActive">
                  <template v-if="shortlistStateStore.selectedCount > 0">
                    {{ shortlistStateStore.selectedCount }} selected
                  </template>

                  <template v-else>
                    {{ shortlistStateStore.shortlistedPropertiesCount }}
                    {{
                      shortlistStateStore.shortlistedPropertiesCount === 1
                        ? 'property'
                        : 'properties'
                    }}
                  </template>
                </template>

                <template v-else-if="housemateGroupsActive">
                  {{ studentStore.searchSubMenuHeaderCount }}
                  {{
                    studentStore.searchSubMenuHeaderCount === 1
                      ? 'property'
                      : 'properties'
                  }}
                </template>

                <template v-else-if="userEnquiriesActive">
                  {{ studentStore.searchSubMenuHeaderCount }} enquiries
                </template>
              </span>

              <span
                v-if="showStudentAccomodationInformation"
                class="tw-mt-[12px] tw-hidden tw-self-baseline tw-text-[14px] tw-text-sm tw-leading-[21px] tw-text-[#5C6A75] xl:tw-inline"
              >
                Use filters for room and price to find your perfect place.
              </span>
            </h3>

            <h2
              class="tw-mb-0 tw-hidden md:tw-flex md:tw-items-end lg:tw-text-[26px] lg:tw-leading-[38px]"
              dusk="student-accommodation-search-headline"
            >
              <template v-if="showStudentAccomodationInformation">
                Student accommodation
                <span v-if="currentCity">&nbsp;in&nbsp;</span>
                <span
                  v-if="currentCity"
                  class="tw-font-semibold"
                  data-testid="in-current-city-name"
                  >{{ `${currentCity.name}` }}</span
                >
              </template>

              <template v-else-if="shortlistActive">
                <span class="tw-hidden lg:tw-inline"> My Shortlist </span>
              </template>

              <template v-else-if="housemateGroupsActive">
                <span class="tw-hidden lg:tw-inline">
                  {{ studentStore.searchSubMenuHeaderText }}
                </span>
              </template>

              <template v-else-if="userEnquiriesActive">
                <span class="tw-hidden lg:tw-inline"> Enquiries </span>
              </template>
            </h2>
          </div>
        </div>

        <div class="tw-flex tw-flex-col tw-items-end tw-self-start">
          <div class="tw-flex">
            <!-- + Views -->
            <div
              v-if="showMapControls"
              class="display-flex ml-auto mx-0 tw-mt-[6px] tw-hidden lg:tw-block"
            >
              <button
                v-if="propertiesData.length && canShowMapView"
                id="show_map"
                ref="showMap"
                :class="[
                  'align-items-center d-flex justify-content-center ml-auto mr-0 p-10px min-w-40px tw-touch-manipulation tw-border-transparent tw-bg-transparent tw-px-[8px] tw-py-0 tw-text-[16px] tw-leading-[32px] tw-text-[#5C6A75] hover:tw-text-black focus:tw-text-black disabled:tw-bg-transparent',
                  {
                    'tw-cursor-not-allowed tw-opacity-40':
                      studentStore.isHousemateGroupManageMode,
                  },
                ]"
                title="Show the map"
                type="button"
                dusk="desktop-show-map"
                :disabled="studentStore.isHousemateGroupManageMode"
                :aria-disabled="
                  studentStore.isHousemateGroupManageMode ? 'true' : 'false'
                "
                @click.prevent="toggleMap"
              >
                <i class="fas view-on-map font-size-20px pr-10px" />
                <span
                  class="d-md-none pr-10px font-weight-600 tw-text-[16px] tw-leading-[32px]"
                  >{{ mapIsOpen ? 'Close' : 'Map' }}</span
                >
                <span
                  class="d-none d-md-block pr-10px font-weight-600 tw-text-[16px] tw-leading-[32px]"
                  >{{ mapIsOpen ? 'Close map' : 'View on map' }}</span
                >
              </button>
            </div>
            <!-- - Views -->
            <!-- + Sorting -->
            <div
              v-if="showSortControls"
              :class="[
                'display-flex mr-0 pl-10px tw-ml-auto tw-mt-[6px] tw-hidden md:tw-block',
              ]"
            >
              <div
                class="custom-select-wrapper-bw"
                :class="{
                  'tw-pointer-events-none tw-opacity-40':
                    studentStore.isHousemateGroupManageMode,
                }"
                :aria-disabled="
                  studentStore.isHousemateGroupManageMode ? 'true' : 'false'
                "
                data-uh="sort-by"
                data-label="properties-search-main-backup-2024-1"
                dusk="desktop-sort-by"
              >
                <div class="border-none custom-select noSelect">
                  <div
                    :class="[
                      'align-items-center d-flex justify-content-center ml-auto mr-0 min-w-40px tw-cursor-pointer tw-border-transparent tw-px-[8px] tw-text-[16px] tw-leading-[32px] tw-text-[#5C6A75] hover:tw-text-black focus:tw-text-black',
                      {
                        disabled:
                          reloading || studentStore.isHousemateGroupManageMode,
                      },
                    ]"
                  >
                    <span
                      class="d-md-none pr-10px font-weight-600 tw-text-[16px] tw-leading-[32px]"
                      >{{ displayedCurrentSortTitleShort }}</span
                    >
                    <span
                      class="d-none d-md-block pr-10px font-weight-600 tw-text-[16px] tw-leading-[32px]"
                      >{{ displayedCurrentSortTitle }}</span
                    >
                    <div class="arrow-off">
                      <i class="fas sort-by-search font-size-20px sort"></i>
                    </div>
                  </div>
                  <div
                    class="custom-options l-minus-120px tw-z-20 tw-rounded-[16px] tw-p-0 tw-drop-shadow-md"
                    data-uh="sort-by-results"
                    dusk="desktop-sort-by-results"
                  >
                    <span
                      v-for="(value, key, index) in displayedSortOptions"
                      :key="index"
                      class="custom-option transition-all duration-300 ease-in-out tw-m-0 tw-px-[24px] tw-py-[16px]"
                      :class="{
                        selected: activeSortKey === key,
                        'tw-border-t-[1px] tw-border-[#E5E7EB]': index !== 0,
                      }"
                      :data-uh="`sort-by-${key}`"
                      :dusk="`sort-by-${key}`"
                      @click="handleSortChange(key)"
                    >
                      {{ value.full }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- - Sorting -->
        </div>
      </div>
    </div>
    <!-- - Sorting and Map Button Desktop -->

    <UpcomingPropertiesBanner
      v-if="displayUpcomingPropertiesBanner"
    ></UpcomingPropertiesBanner>

    <!-- + Map -->
    <div class="row tw-justify-center" data-component="map-container">
      <div
        ref="propertiesListMap"
        class="container-fluid tw-p-0"
        :class="{ contained: !mapIsOpen }"
      >
        <div class="row">
          <!-- + Map -->

          <div
            v-if="mapIsOpen"
            class="tw-flex tw-h-[calc(100vh-64px)] tw-w-full tw-flex-col tw-bg-white"
          >
            <OpenMap
              :center="[currentCity.longitude, currentCity.latitude]"
              :enable-housemate-groups="housemateGroupsEnabled"
              :enable-shortlist-in-search="shortlistInSearchEnabled"
              :is-logged-in-student="isLoggedInStudent"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Map -->

    <!-- - Properties List -->
    <div
      v-if="!showMobilePropertyTypeFiltersOnlyMode"
      v-show="!mapIsOpen"
      ref="listContainer"
      class="row tw-justify-center"
      data-component="list-container"
    >
      <div
        ref="propertiesListMap"
        class="container-fluid tw-max-w-screen-xl tw-p-0"
        :class="{
          contained: !mapIsOpen,
          'updated-property-tile-container': enableUpdatedPropertyTile,
        }"
      >
        <div class="row">
          <!-- + Side Buttons -->
          <div
            class="col-1 tw-hidden tw-border-r tw-border-gray-200 md:tw-block md:tw-px-[24px]"
          >
            <SearchNavSubMenu
              v-if="housemateGroupsEnabled"
              :class="desktopSubMenuStickyClasses"
              :vertical-menu-tab="true"
              :enable-housemate-groups="housemateGroupsEnabled"
              :is-logged-in-student="isLoggedInStudent"
              :has-enquired-properties="hasEnquiredProperties"
              :shortlist-active="shortlistActive"
              :show-housemate-group-tab="showHousemateGroupTab"
              :housemate-group-active="housemateGroupsActive"
              :user-enquiries-active="userEnquiriesActive"
              @toggle-short-list="toggleShortList"
              @toggle-housemate-group="toggleHousemateGroup"
              @toggle-user-enquiry="toggleUserEnquiry"
            />
          </div>
          <!-- - Side Buttons -->

          <!-- + List -->
          <div
            ref="propertiesList"
            class="col-12 properties_listing_container col-md-11"
            :class="{
              'col-lg-6 d-none d-lg-block': mapIsOpen,
              'uh-housemate-group-tiles-wrap':
                !mapIsOpen &&
                ((showSearchPage && housemateGroupsEnabled) ||
                  shortlistActive ||
                  housemateGroupsActive),
            }"
          >
            <div class="position-relative row">
              <div
                v-if="!propertyCount"
                ref="no-results"
                class="col-12 py-20px"
                :class="{ 'display-none': !showNoResults }"
              >
                <h3>No results</h3>
                <p class="mb-20px">
                  Try adjusting your search by removing filters or zooming out
                  on the map
                </p>
                <a class="btn btn-bc01 mb-10px mr-20px" :href="currentUrl">
                  Remove all filters
                </a>
                <button
                  ref="zoomOut"
                  type="button"
                  class="btn btn-bc01 mb-10px mr-20px"
                  data-action="zoom-out"
                  @click="$emit('zoom-out', null)"
                >
                  Zoom Out
                </button>
              </div>

              <div
                class="tw-flex tw-w-full tw-items-center tw-gap-4 tw-p-[18px] max-[350px]:tw-gap-2 md:tw-hidden"
              >
                <!-- Mobile HMG sub nav component -->
                <SearchNavSubMenu
                  v-if="housemateGroupsEnabled"
                  :enable-housemate-groups="housemateGroupsEnabled"
                  :is-logged-in-student="isLoggedInStudent"
                  :has-enquired-properties="hasEnquiredProperties"
                  :shortlist-active="shortlistActive"
                  :show-housemate-group-tab="showHousemateGroupTab"
                  :housemate-group-active="housemateGroupsActive"
                  :user-enquiries-active="userEnquiriesActive"
                  class="tw-block md:tw-hidden"
                  @toggle-short-list="toggleShortList"
                  @toggle-housemate-group="toggleHousemateGroup"
                  @toggle-user-enquiry="toggleUserEnquiry"
                />

                <!-- Sort / Property Type Button -->
                <PropertyTypeFiltersTrigger
                  v-if="enablePropertyTypeFilters && showSortControls"
                  :expanded="propertyTypeFiltersExpanded"
                  :disabled="isSortDisabledOnMobile"
                  class="tw-w-[188px] tw-shrink-0 md:tw-hidden"
                  @toggle="
                    propertyTypeFiltersExpanded = !propertyTypeFiltersExpanded
                  "
                />
                <div
                  v-else-if="showSortControls"
                  class="custom-select-wrapper-bw tw-flex tw-flex-1 md:tw-hidden"
                  data-uh="sort-by"
                  data-label="properties-search-main-backup-2024-0"
                >
                  <div class="custom-select noSelect tw-w-full tw-border-none">
                    <!-- Selected option -->
                    <button
                      v-if="!isSortDisabledOnMobile"
                      type="button"
                      :class="[
                        'tw-flex tw-h-[44px] tw-w-full tw-cursor-pointer tw-touch-manipulation tw-flex-row tw-content-evenly tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[100px] tw-border-[1px] tw-border-[#D1D5DB] tw-bg-white !tw-px-[10px] tw-text-[16px] tw-leading-[32px] tw-text-[#5C6A75] hover:tw-text-black focus:tw-text-black',
                        {
                          disabled: reloading,
                        },
                      ]"
                    >
                      <span class="arrow-off">
                        <i
                          class="fas sort-by-search font-size-20px sort tw-ml-1 tw-pt-[7px]"
                        ></i>
                      </span>
                      <span
                        class="d-md-none tw-inline-block tw-max-w-[120px] tw-overflow-hidden tw-truncate tw-text-ellipsis tw-whitespace-nowrap tw-text-[14px] tw-font-semibold tw-leading-[21px] tw-text-primary-grey"
                        :title="displayedCurrentSortTitleShort"
                      >
                        {{ displayedCurrentSortTitleShort }}
                      </span>
                    </button>
                    <div
                      v-else
                      class="tw-flex tw-h-[44px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[30px] tw-bg-[#9CA3AF] tw-px-[24px] tw-py-[8px]"
                    >
                      <SortButtonDisabled />
                      <span
                        class="tw-font-inter tw-text-center tw-text-[14px] tw-font-semibold tw-leading-[150%] tw-text-white"
                      >
                        Relevance
                      </span>
                    </div>
                    <div
                      class="custom-options tw-left-[-200px] tw-z-20 tw-rounded-[16px] tw-p-0 tw-drop-shadow-md md:tw-left-[-120px]"
                      data-uh="sort-by-results"
                    >
                      <span
                        v-for="(value, key, index) in displayedSortOptions"
                        :key="index"
                        class="custom-option transition-all duration-300 ease-in-out tw-m-0 tw-px-[24px] tw-py-[16px]"
                        :class="{
                          selected: activeSortKey === key,
                          'tw-border-t-[1px] tw-border-[#E5E7EB]': index !== 0,
                        }"
                        :data-uh="`sort-by-${key}`"
                        @click="handleSortChange(key)"
                      >
                        {{ value.full }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <PropertyTypeFiltersExtension
                v-if="enablePropertyTypeFilters && showSortControls"
                class="tw-mb-5 md:tw-hidden"
                :active="currentType"
                :expanded="propertyTypeFiltersExpanded"
                :enable-private-halls-filter="enablePrivateHallsFilter"
                :enable-spare-room-functionality="enableSpareRoomFunctionality"
                :disabled="isSortDisabledOnMobile"
                :show-mobile-trigger="false"
                @update:expanded="propertyTypeFiltersExpanded = $event"
                @change="$emit('set-current-type', $event)"
              />

              <!-- Student accommodation info  -->
              <div
                v-if="showStudentAccomodationInformation"
                class="tw-flex tw-w-full tw-items-start tw-px-[16px] tw-pb-[16px] tw-pt-0 md:tw-hidden"
              >
                <div
                  class="container-fluid contained tw-mx-0 tw-max-w-screen-xl tw-p-0"
                >
                  <h2
                    v-if="currentCity"
                    class="ml-0 mr-auto tw-line tw-font-md tw-text-trueGray-700 tw-mb-0 tw-leading-[27px] xxs:tw-text-[16px] sm:tw-text-[18px] md:tw-mb-0 md:tw-mt-[24px] md:tw-text-[26px] md:tw-leading-[38px]"
                    dusk="student-accommodation-search-headline"
                  >
                    Student accommodation
                    <span>in</span>
                    <span
                      class="tw-font-semibold"
                      data-testid="in-current-city-name"
                      >{{ `${currentCity.name}` }}</span
                    >
                  </h2>
                </div>
              </div>
              <!-- Student accommodation info  -->

              <div
                v-if="!mapIsOpen && !isSubMenuTabActive"
                class="tw-min-w-0 tw-w-full"
              >
                <SpareRoomsNudge
                  v-if="
                    showSpareRoomsOneBedNudge &&
                    spareRoomsOneBedOverlayCount > 0
                  "
                  :count="spareRoomsOneBedOverlayCount"
                  :apply-url="spareRoomsOneBedOverlayApplyUrl"
                />
              </div>

              <!-- Property Listings -->
              <div class="col-12">
                <div
                  id="properties_listing_container"
                  :class="[
                    'row',
                    {
                      'updated-property-tile-grid': enableUpdatedPropertyTile,
                      'uh-housemate-group-tiles':
                        !mapIsOpen &&
                        ((showSearchPage && housemateGroupsEnabled) ||
                          shortlistActive ||
                          housemateGroupsActive),
                    },
                  ]"
                  data-hybrid="1"
                >
                  <template
                    v-if="showSearchPage && !(userEnquiriesActive && reloading)"
                  >
                    <div
                      v-for="(property, index) in propertiesData"
                      :key="
                        property.id
                          ? `property-${property.id}`
                          : `property-${index}`
                      "
                      class="tw-contents"
                    >
                      <div
                        :data-vwo-property-type="
                          isSpecialListing(property)
                            ? null
                            : property.isBTRProperty
                            ? 'btr-search-page'
                            : 'hmo-search-page'
                        "
                        :data-id="property.id"
                        :class="[
                          {
                            'col-12 col-sm-6 property-listing-column tw-mb-[18px] md:tw-mb-[36px]':
                              !isGuideBanner(property) && !mapIsOpen,
                            [propertyColumnClass]:
                              !isGuideBanner(property) && !mapIsOpen,
                            'col-12 col-sm-6 property-listing-column mb-20px':
                              !isGuideBanner(property) && mapIsOpen,
                            'col-12 col-sm-12 mb-20px banner-listing-column':
                              isGuideBanner(property),
                            'z-i-3':
                              shortlistNudgeEnabled &&
                              !isSpecialListing(property) &&
                              [3, 5].includes(getPropertyIteration(index)),
                            'disabled-off': reloading,
                          },
                        ]"
                        :data-map-marker="!isSpecialListing(property)"
                      >
                        <PropertyListingFeatured
                          v-if="
                            !isSpecialListing(property) &&
                            property.isFeatured &&
                            !(
                              property.lastEnquiredAt ||
                              property.housemateGroupLastEnquiredAt ||
                              property.housemate_group_last_enquired_at
                            ) &&
                            !enableUpdatedPropertyTile &&
                            enableUpdatedFeaturedProperties
                          "
                          :admin="admin"
                          :map-is-open="mapIsOpen"
                          :is-logged-in-student="isLoggedInStudent"
                          :admin-first-name="adminFirstName"
                          :bottom-of-the-page="bottomOfThePage"
                          :current-scroll="currentScroll"
                          :iteration="getPropertyIteration(index)"
                          :paginate="paginate"
                          :property="property"
                          :reloading="reloading"
                          :screen-key="screenKey"
                          :shortlist-nudge-enabled="shortlistNudgeEnabled"
                          :window-height="windowHeight"
                          :enable-housemate-groups="housemateGroupsEnabled"
                          :enable-shortlist-in-search="shortlistInSearchEnabled"
                          :show-housemate-group-tab="showHousemateGroupTab"
                          :housemate-group-active="
                            housemateGroupsActive &&
                            studentStore.showHousemateGroupDetail
                          "
                          :housemate-group-id="activeHousemateGroupId"
                          @housemate-group-vote="handleHousemateGroupVote"
                        />

                        <PropertyListingBackup2024
                          v-else-if="!isSpecialListing(property)"
                          :enable-updated-property-tile="
                            enableUpdatedPropertyTile
                          "
                          :admin="admin"
                          :map-is-open="mapIsOpen"
                          :is-logged-in-student="isLoggedInStudent"
                          :admin-first-name="adminFirstName"
                          :bottom-of-the-page="bottomOfThePage"
                          :current-scroll="currentScroll"
                          :iteration="getPropertyIteration(index)"
                          :paginate="paginate"
                          :property="property"
                          :reloading="reloading"
                          :screen-key="screenKey"
                          :shortlist-nudge-enabled="shortlistNudgeEnabled"
                          :window-height="windowHeight"
                          :enable-housemate-groups="housemateGroupsEnabled"
                          :show-housemate-group-tab="showHousemateGroupTab"
                          :housemate-group-active="
                            housemateGroupsActive &&
                            studentStore.showHousemateGroupDetail
                          "
                          :housemate-group-id="activeHousemateGroupId"
                          @housemate-group-vote="handleHousemateGroupVote"
                        />
                        <div
                          v-else
                          class="guide_banner shadow min-h-200px bg-white rounded-1 col-12"
                        >
                          <div class="banner_image min-h-100 position-relative">
                            <img
                              v-lazy="cityGuideImage.src"
                              :data-srcset="cityGuideImage.srcset"
                              :alt="currentAreaName || currentCityName"
                              loading="lazy"
                              class="banner_image_src"
                            />
                          </div>
                          <div class="banner_copy direction-ltr">
                            <h3 class="font-size-24px font-weight-700">
                              Ultimate Student Guide to
                              {{ currentAreaName || currentCityName }}
                            </h3>
                            <p>
                              Not sure where to live next year? Get opinions
                              from real students about the area.
                            </p>
                            <a
                              :href="
                                currentAreaGuidePath || currentCityGuidePath
                              "
                              target="_blank"
                              rel="noopener noreferrer"
                              data-uh="view-guide"
                              class="btn btn-bc02-b border-1px border-solid rounded-1 min-w-250px position-relative px-32px font-weight-600"
                            >
                              View Guide
                            </a>
                          </div>
                        </div>
                      </div>

                      <!-- Info Section conditionally displayed based on the index -->
                      <div
                        v-if="shouldShowInfoDiv(index, currentPage)"
                        class="col-12 uh-property-grid-full"
                      >
                        <SearchResultsUtilityBanner
                          :city-name="currentCityName"
                          :variant="
                            showContentsInsuranceBanner
                              ? 'contents-insurance'
                              : 'bills'
                          "
                        />
                      </div>
                    </div>
                  </template>

                  <HousemateGroups
                    v-if="
                      housemateGroupsActive &&
                      !showSearchPage &&
                      !studentStore.showHousemateGroupDetail
                    "
                    :is-logged-in-student="isLoggedInStudent"
                    :cities="cities"
                    :all-universities="allUniversities"
                    :universities="universities"
                  />
                  <HousemateGroupDetail
                    v-if="
                      housemateGroupsActive &&
                      !showSearchPage &&
                      studentStore.showHousemateGroupDetail
                    "
                    :enable-housemate-groups="housemateGroupsEnabled"
                    :enable-updated-property-tile="enableUpdatedPropertyTile"
                    :cities="cities"
                    :all-universities="allUniversities"
                    :universities="universities"
                    :sort-key="activeSortKey"
                    :force-skeleton="grouplistTabLoading"
                    :page="currentPage"
                    :paginate="paginate"
                  />

                  <UserShortlists
                    v-if="shortlistActive"
                    :enable-housemate-groups="housemateGroupsEnabled"
                    :enable-updated-property-tile="enableUpdatedPropertyTile"
                    :show-housemate-group-tab="showHousemateGroupTab"
                    :is-logged-in-student="isLoggedInStudent"
                    :admin="admin"
                    :admin-first-name="adminFirstName"
                    :bottom-of-the-page="bottomOfThePage"
                    :current-scroll="currentScroll"
                    :window-height="windowHeight"
                    :screen-key="screenKey"
                    :map-is-open="mapIsOpen"
                    :shortlist-nudge-enabled="shortlistNudgeEnabled"
                    :current-bedrooms="currentBedrooms"
                    :current-bathrooms="currentBathrooms"
                    :current-min-price="currentMinPrice"
                    :current-max-price="currentMaxPrice"
                    :min-price-selected="minPriceSelected"
                    :max-price-selected="maxPriceSelected"
                    :current-type="currentType"
                    :current-landlord="currentLandlord"
                    :use-exact-room-counts="useExactRoomCounts"
                    :page="currentPage"
                    :paginate="paginate"
                    :sort-key="activeSortKey"
                  />

                  <UserEnquiries
                    v-if="
                      userEnquiriesActive &&
                      !reloading &&
                      (!isLoggedInStudent || !propertyCount)
                    "
                    :is-logged-in-student="isLoggedInStudent"
                  />

                  <PropertyCardsSkeleton
                    v-if="userEnquiriesActive && reloading"
                  />
                </div>

                <div
                  v-if="paginate"
                  ref="hideOnMapCountZero"
                  class="hide-on-map-count-zero row"
                  :class="{ 'display-none': shouldHidePaginationForMapCount }"
                >
                  <div class="col-12">
                    <div v-if="propertiesHasMorePages && !initialPage && false">
                      <div
                        v-if="!loading"
                        class="property_page_view_more max-w-100"
                      >
                        <div class="col-12 col-sm-6 col-xl-4 px-0 mx-auto">
                          <div
                            class="bg-white h-8px mt-24px mb-16px p-0 position-relative rounded-1"
                          >
                            <span
                              id="meter"
                              class="bg-primary d-block h-100 overflow-hidden position-relative rounded-1"
                              :data-property-count="propertyCount"
                              :style="'width:' + meter + '%'"
                            ></span>
                          </div>
                          <p class="font-size-16px mb-24px">
                            Viewing
                            <span id="viewing">{{ propertiesCount }}</span>
                            of
                            {{
                              propertyCount +
                              ' ' +
                              pluralise('property', propertyCount)
                            }}
                          </p>
                          <button
                            type="button"
                            class="btn btn-bc02 property_page_view_more_button w-100"
                            @click="$emit('show-more-properties', null)"
                          >
                            Show More
                          </button>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="bg-offwhite infinite-scroll-request max-w-100 property_page_results"
                        >
                          <i
                            class="fas fa-spinner fa-lg fa-spin fa-2x text-primary"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        computedNumberOfPages > 1 &&
                        (!isSubMenuTabActive || isLoggedInStudent)
                      "
                      class="row tw-mb-[100px] tw-mt-[100px]"
                    >
                      <nav
                        id="property-pagination-wrapper"
                        class="align-items-center d-flex flex-direction-column w-full mx-auto min-[576px]:tw-w-[80%] md:tw-px-0 lg:tw-w-auto"
                      >
                        <CustomPagination
                          v-model="currentPage"
                          :model-value="currentPage"
                          :active-class="'tw-bg-primary-color tw-text-white'"
                          :break-view-class="'break-view-class'"
                          :break-view-link-class="'bg-transparent tw-self-center break-view-link-class tw-text-primary-color'"
                          :break-view-text="'-'"
                          :click-handler="handlePagination"
                          :disabled-class="'!tw-bg-transparent tw-text-[#E5E7EB]'"
                          :margin-pages="1"
                          :next-class="'next-class'"
                          :next-link-class="'tw-text-primary-color align-items-center d-flex tw-font-bold tw-text-[14px] tw-leading-[27px] tw-h-[34px] md:tw-h-[48px] md:tw-w-[48px] hover:tw-text-[#00628F] justify-content-center page-link-class rounded-circle'"
                          :page-class="'page-class'"
                          :page-count="computedNumberOfPages"
                          :page-link-class="'tw-text-primary-color hover:tw-bg-primary-color hover:tw-text-white md:tw-mx-[0] align-items-center d-flex tw-font-bold tw-text-[14px] tw-leading-[27px] tw-w-[34px] tw-h-[34px] tw-min-w-[34px] md:tw-min-w-[48px] md:tw-h-[48px] md:tw-w-[48px] hover:tw-[#00628F] justify-content-center page-link-class rounded-circle'"
                          :page-range="paginationPageRangeBreakPoints"
                          :prev-class="'tw-text-primary-color tw-h-[34px] md:tw-h-[48px] prev-class'"
                          :prev-link-class="'align-items-center d-flex tw-font-bold tw-text-[14px] tw-leading-[27px] tw-h-[34px] md:tw-h-[48px] md:tw-w-[48px] hover:tw-text-[#00628F] justify-content-center page-link-class rounded-circle'"
                          :container-class="'d-flex list-style-none mx-auto mb-20px tw-justify-center tw-gap-[14px] tw-justify-between tw-w-full'"
                          :prev-text="`<i class='far fa-chevron-left tw-text-[14px] tw-mr-[6px]'></i> <span class='tw-text-[15px] md:tw-mr-0'>Prev </span>`"
                          :next-text="`<span class='md:tw-ml-0 tw-inline-block tw-pr-[6px] tw-text-[15px]'>Next </span> <i class='far fa-chevron-left tw-text-[14px] tw-rotate-180'></i>`"
                        >
                        </CustomPagination>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
              <!-- + Nearby -->
              <div
                v-if="displayNearby && showSearchPage"
                ref="nearby"
                class="col-12"
              >
                <div class="row">
                  <div class="col-12 py-20px">
                    <h3
                      class="mb-4px tw-text-trueGray-700 tw-mt-[24px] tw-text-[26px] tw-leading-[38px]"
                    >
                      More student accommodation nearby
                    </h3>
                    <p
                      id="similar-properties-prompt"
                      class="tw-text-[14px] tw-text-sm tw-leading-[21px] tw-text-[#5C6A75]"
                    ></p>
                  </div>
                  <div class="col-12">
                    <div
                      id="properties_nearby_listing_container"
                      class="row"
                      :class="{
                        'updated-property-tile-grid': enableUpdatedPropertyTile,
                      }"
                    >
                      <div
                        v-for="(property, index) in nearby"
                        :key="`nearby-${property.id}`"
                        class="col-12 col-sm-6 property-listing-column mb-20px"
                        :class="[
                          propertyColumnClass,
                          {
                            'z-i-3':
                              shortlistNudgeEnabled &&
                              [3, 5].includes(index + 1),
                            'disabled-off': reloading,
                          },
                        ]"
                        :data-id="property.id"
                        data-map-marker="true"
                      >
                        <PropertyListingBackup2024
                          :abbreviate="true"
                          :enable-updated-property-tile="
                            enableUpdatedPropertyTile
                          "
                          :enable-housemate-groups="housemateGroupsEnabled"
                          :enable-shortlist-in-search="shortlistInSearchEnabled"
                          :admin="admin"
                          :admin-first-name="adminFirstName"
                          class-list="h-100 m-0"
                          :hide-buttons="true"
                          img-classes="max-h-180px-off max-w-100'"
                          :iteration="index + 1"
                          listing="nearby"
                          :property="property"
                          :reloading="reloading"
                          :screen-key="screenKey"
                          :shortlist-nudge-enabled="shortlistNudgeEnabled"
                        >
                        </PropertyListingBackup2024>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- - Nearby -->
            </div>
          </div>
          <!-- - List -->
        </div>
      </div>
    </div>
    <!-- - Properties ListMap -->

    <!-- Sticky Mobile Map Button -->
    <button
      v-if="
        showStickyButton &&
        propertyCount > 0 &&
        (isMobile || isTablet) &&
        canShowMapView &&
        showMapControls &&
        showSearchPage
      "
      ref="mapViewStickyButton"
      type="button"
      :class="[
        'tw-fixed tw-left-1/2 tw-z-[9999] tw-mb-4 tw-flex tw-h-[40px] -tw-translate-x-1/2 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-full tw-bg-[#0082B8] tw-px-[16px] tw-py-0 tw-text-white tw-shadow-lg tw-transition-[opacity,bottom] tw-duration-200 tw-ease-in-out',
        {
          'tw-cursor-not-allowed tw-opacity-40':
            studentStore.isHousemateGroupManageMode,
        },
      ]"
      :disabled="studentStore.isHousemateGroupManageMode"
      :aria-disabled="
        studentStore.isHousemateGroupManageMode ? 'true' : 'false'
      "
      @click="toggleMap"
    >
      <img
        alt="View Map"
        class="tw-h-[24px] tw-w-[24px] tw-pr-[4px]"
        :src="cdnAsset('svg/uh-view-map-icon-white.svg')"
      />
      <span class="tw-!text-white tw-text-sm tw-font-semibold"> Map view </span>
    </button>
    <!-- - Sticky Mobile Map Button -->
  </div>
  <!-- - Properties List -->
</template>
<script>
import PropertyListingBackup2024 from '@components/PropertyListingBackup2024.vue';
import Pluralize from 'pluralize';
import CustomPagination from '@components/CustomPagination.vue';
import UpcomingPropertiesBanner from '@components/Property/UpcomingPropertiesBanner.vue';
import OpenMap from '@components/properties-search/components/OpenMap.vue';
import { useMapStore } from '@js/stores/map/mapStore';
import PropertyListingFeatured from '@components/PropertyListingFeatured.vue';
import { getCurrentPath } from '@js/utilities';
import HousemateGroups from '@components/Student/HousemateGroups.vue';
import UserShortlists from '@components/Student/UserShortlists.vue';
import UserEnquiries from '@components/Student/UserEnquiries.vue';
import PropertyCardsSkeleton from '@components/Student/PropertyCardsSkeleton.vue';
import SearchResultsUtilityBanner from '@components/properties-search/components/SearchResultsUtilityBanner.vue';
import { useStudentStore } from '@js/stores/student/student';
import SearchNavSubMenu from '@components/Student/Nav/SearchNavSubMenu.vue';
import SortButtonDisabled from '@components/Student/SVG/SortButtonDisabled.vue';
import HousemateGroupDetail from '@components/Student/HousemateGroupDetail.vue';
import PropertyTypeFiltersExtension from '@components/Property/MobileSearchFilters/PropertyTypeFiltersExtension.vue';
import PropertyTypeFiltersTrigger from '@components/Property/MobileSearchFilters/PropertyTypeFiltersTrigger.vue';
import {
  buildShortlistFilters,
  getFilteredShortlist,
} from '@components/Student/shortlistFilters';
import SpareRoomsNudge from '@components/properties-search/components/SpareRoomsNudge.vue';

export default {
  components: {
    SearchResultsUtilityBanner,
    HousemateGroupDetail,
    PropertyTypeFiltersExtension,
    PropertyTypeFiltersTrigger,
    SortButtonDisabled,
    SearchNavSubMenu,
    PropertyListingFeatured,
    OpenMap,
    CustomPagination,
    PropertyListingBackup2024,
    UpcomingPropertiesBanner,
    HousemateGroups,
    UserShortlists,
    UserEnquiries,
    PropertyCardsSkeleton,
    SpareRoomsNudge,
  },

  props: {
    enableNewMap: {
      default: false,
      type: Boolean,
    },
    enableMarketplaceGridSplitMaps: {
      default: false,
      type: Boolean,
    },
    enableUpdatedFeaturedProperties: {
      default: false,
      type: Boolean,
    },
    enableUpdatedPropertyTile: {
      default: false,
      type: Boolean,
    },
    showUpcomingPropertiesBanner: {
      default: false,
      type: Boolean,
    },
    showContentsInsuranceBanner: {
      default: false,
      type: Boolean,
    },
    admin: {
      default: false,
      type: Boolean,
    },
    areas: {
      default: function () {
        return [];
      },
      type: Array,
    },
    adminFirstName: {
      default: null,
      type: String,
    },
    bottomOfThePage: {
      default: window.innerHeight,
      type: Number,
    },
    cities: {
      default: function () {
        return [];
      },
      type: Array,
    },
    allUniversities: {
      default: function () {
        return [];
      },
      type: Array,
    },
    universities: {
      default: function () {
        return [];
      },
      type: Array,
    },
    currentAreaSlug: {
      default: null,
      type: String,
    },
    currentCitySlug: {
      default: null,
      type: String,
    },
    currentBedrooms: {
      default: null,
      type: [Number, String],
    },
    currentBathrooms: {
      default: null,
      type: [Number, String],
    },
    currentMinPrice: {
      default: null,
      type: [Number, String],
    },
    currentMaxPrice: {
      default: null,
      type: [Number, String],
    },
    minPriceSelected: {
      default: false,
      type: Boolean,
    },
    maxPriceSelected: {
      default: false,
      type: Boolean,
    },
    currentScroll: {
      default: 0,
      type: Number,
    },
    currentSort: {
      default: null,
      type: String,
    },
    currentSortTitle: {
      default: null,
      type: String,
    },
    currentSortTitleShort: {
      default: null,
      type: String,
    },
    currentType: {
      default: null,
      type: [String, Array],
    },
    enablePrivateHallsFilter: {
      default: false,
      type: Boolean,
    },
    enableSpareRoomFunctionality: {
      default: false,
      type: Boolean,
    },
    enablePropertyTypeFilters: {
      default: false,
      type: Boolean,
    },
    currentLandlord: {
      default: null,
      type: [Object, String],
    },
    currentUrl: {
      default: null,
      type: String,
    },
    displayNearby: {
      default: false,
      type: Boolean,
    },
    hideNearby: {
      default: false,
      type: Boolean,
    },
    initialPage: {
      default: null,
      type: [Number, String],
    },
    loading: {
      default: false,
      type: Boolean,
    },
    mapCountZero: {
      default: false,
      type: Boolean,
    },
    mapMoveUp: {
      default: false,
      type: Boolean,
    },
    nearby: {
      default: function () {
        return [];
      },
      type: Array,
    },
    numberOfPages: {
      default: 1,
      type: Number,
    },
    page: {
      default: null,
      type: [Number, String],
    },
    paginate: {
      default: 0,
      type: Number,
    },
    properties: {
      default: function () {
        return [];
      },
      type: Array,
    },
    propertiesCount: {
      default: 0,
      type: Number,
    },
    propertiesHasMorePages: {
      default: false,
      type: Boolean,
    },
    propertiesSliderSlides: {
      default: null,
      type: Array,
    },
    propertyCount: {
      default: 0,
      type: Number,
    },
    reloading: {
      default: false,
      type: Boolean,
    },
    screenKey: {
      default: null,
      type: String,
    },
    shortlistNudgeEnabled: {
      default: false,
      type: Boolean,
    },
    showNearby: {
      default: 0,
      type: Number,
    },
    showNoResults: {
      default: false,
      type: Boolean,
    },
    sortOptions: {
      default: function () {
        return {};
      },
      type: Object,
    },
    title: {
      default: null,
      type: String,
    },
    titleResultsCount: {
      default: null,
      type: [Number, String],
    },
    windowHeight: {
      default: window.innerHeight,
      type: Number,
    },
    zoomLevel: {
      default: 12,
      type: Number,
    },
    enquiredProperties: {
      default: false,
      type: Boolean,
    },
    isLoggedInStudent: {
      default: false,
      type: Boolean,
    },
    useExactRoomCounts: {
      default: false,
      type: Boolean,
    },
    enableHousemateGroups: {
      default: null,
      type: Boolean,
    },
    enableShortlistInSearch: {
      default: false,
      type: Boolean,
    },
    hasEnquiredProperties: {
      default: false,
      type: Boolean,
    },
    housemateGroupShowShortlistTab: {
      default: false,
      type: Boolean,
    },
    showHousemateGroupTab: {
      default: false,
      type: Boolean,
    },
    openHousemateGroupTab: {
      default: false,
      type: Boolean,
    },
    desktopPropertyFiltersOpen: {
      default: false,
      type: Boolean,
    },
    showMobilePropertyTypeFiltersOnly: {
      default: false,
      type: Boolean,
    },
    showSpareRoomsOneBedNudge: {
      default: false,
      type: Boolean,
    },
    spareRoomsOneBedOverlayCount: {
      default: 0,
      type: Number,
    },
    spareRoomsOneBedOverlayApplyUrl: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      studentStore: useStudentStore(),
      shortlistStateStore: useStudentStore(),
      windowWidth: window.innerWidth,
      showStickyButton: false,
      paginationVisible: false,
      paginationObserver: null,
      housemateGroupsActive: false,
      showHousemateGroupDetail: false,
      housemateGroupToggleCounter: 0,
      shortlistActive: false,
      userEnquiriesActive: false,
      showSearchPage: true,
      localProperties: [],
      grouplistTabLoading: false,
      shortlistSortKey: null,
      grouplistSortKey: null,
      enquiriesSortKey: null,
      localTabPage: 1,
      propertyTypeFiltersExpanded: true,
    };
  },

  computed: {
    propertyColumnClass() {
      return this.enableUpdatedPropertyTile
        ? 'col-lg-4 property-tile-column'
        : 'col-xl-4';
    },
    mapStore() {
      return useMapStore();
    },
    mapIsOpen() {
      return this.mapStore.mapIsOpen;
    },
    canShowMapView() {
      const currentPath = this.getCurrentPath();
      return (
        currentPath &&
        currentPath !== '/student-accommodation' &&
        this.enableNewMap
      );
    },
    canShowGridSplitMaps() {
      return Boolean(
        this.canShowMapView && this.enableMarketplaceGridSplitMaps
      );
    },
    housemateGroupsEnabled() {
      return Boolean(this.enableHousemateGroups);
    },
    shortlistInSearchEnabled() {
      return Boolean(this.enableShortlistInSearch);
    },
    desktopSubMenuStickyClasses() {
      return {
        'md:tw-sticky': true,
        'md:tw-pb-[120px]': true,
        'md:tw-top-[144px]': !this.desktopPropertyFiltersOpen,
        'md:tw-top-[224px]': this.desktopPropertyFiltersOpen,
      };
    },
    /**
    Three-up is as wide as this grid gets. The four-up rule at 1343 is written
    as a child of .updated-property-tile-grid, and here the v-for wraps every
    column in a display:contents div, which flattens the layout but not the
    selector, so the rule never lands. It is the right answer regardless: the
    listing container carries a col-md-11 the search page does not, leaving
    1186px against its 1304px, so four-up here would be 272px cards where the
    breakpoint is drawn for 302.
     */
    updatedTileGridColumns() {
      const width = this.windowWidth;

      if (width >= 992) {
        return 3;
      }
      if (width >= 576) {
        return 2;
      }

      return 1;
    },
    /**
    The banner is full width, so it breaks whichever row it lands in. Round the
    four card target the design asks for up to the end of a row, which lands it
    after 4 cards four-up, 6 three-up and 4 two-up.
     */
    infoDivIndex() {
      const columns = this.updatedTileGridColumns;

      return Math.ceil(4 / columns) * columns - 1;
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    showMobilePropertyTypeFiltersOnlyMode() {
      return this.showMobilePropertyTypeFiltersOnly && this.isMobile;
    },
    isTablet() {
      return this.windowWidth < 1024;
    },
    paginationPageRangeBreakPoints() {
      const width = this.windowWidth;

      if (this.mapIsOpen && width >= 992) {
        return 3;
      } else if (width >= 992) {
        return 9;
      } else if (width >= 768) {
        return 5;
      } else {
        return 2;
      }
    },
    currentArea() {
      var scope = this;
      return scope.currentAreaSlug
        ? this.areas.filter(function (area) {
            return area.slug === scope.currentAreaSlug;
          })[0]
        : null;
    },
    currentAreaName() {
      return this.currentArea ? this.currentArea.name : null;
    },
    currentAreaGuidePath() {
      return this.currentArea ? this.currentArea.guide_path : null;
    },
    currentCity() {
      var scope = this;
      return scope.currentCitySlug
        ? this.cities.filter(function (city) {
            return city.id === scope.currentCitySlug;
          })[0]
        : null;
    },
    currentCityName() {
      return this.currentCity ? this.currentCity.name : null;
    },
    currentCityGuidePath() {
      return this.currentCity ? this.currentCity.guide_path : null;
    },
    cityGuideImage() {
      const image = { src: '', srcset: '' };

      if (this.currentArea && this.currentArea.src) {
        image.src = this.currentArea.src.homepage.url;
        image.srcset = this.currentArea.src.homepage.srcset;
      }

      if (this.currentCity && this.currentCity.src) {
        image.src = this.currentCity.src.homepage.url;
        image.srcset = this.currentCity.src.homepage.srcset;
      }

      return image;
    },
    currentEndCount() {
      return this.propertyCount
        ? Math.min(this.page * this.paginate, this.propertyCount)
        : null;
    },
    currentMaxPropertyCount() {
      if (this.propertyCount < 100) return this.propertyCount;

      // If total is greater than 1000 round down to the nearest 1000
      const roundedTo = this.propertyCount > 1000 ? 1000 : 100;
      // Turn total properties into a whole number before multiplying by the number rounded to
      const nearestNumber =
        Math.floor(this.propertyCount / roundedTo) * roundedTo;

      return `${nearestNumber}+`;
    },
    searchPromoOffset() {
      return 0;
    },
    currentPage: {
      get: function () {
        if (this.shortlistActive || this.housemateGroupsActive) {
          return this.localTabPage;
        }

        return this.page;
      },
      set: function (value) {
        const nextPage = Math.max(1, Number(value) || 1);

        if (this.shortlistActive || this.housemateGroupsActive) {
          this.localTabPage = nextPage;
          return;
        }

        this.$emit('set-page', nextPage);
      },
    },
    meter() {
      return this.propertyCount
        ? Math.min(
            Math.ceil(
              (((this.page ? this.page : 1) * this.paginate) /
                this.propertyCount) *
                100
            ),
            100
          )
        : 0;
    },
    propertiesData() {
      return this.localProperties;
    },
    displayUpcomingPropertiesBanner() {
      return (
        this.showUpcomingPropertiesBanner &&
        this.currentCity &&
        this.currentCity.country === 'GB-SCT'
      );
    },
    showStudentAccomodationInformation() {
      return (
        !this.mapIsOpen &&
        this.showSearchPage &&
        !this.userEnquiriesActive &&
        !this.enquiredProperties
      );
    },

    hasApprovedHousemateGroups() {
      return !!this.studentStore.hasApprovedHousemateGroups;
    },

    housemateGroupPropertiesCount() {
      return this.housemateGroupShortlistsCollection.length;
    },
    housemateGroupShortlistsCollection() {
      return Array.isArray(this.studentStore.housemateGroupShortlists)
        ? this.studentStore.housemateGroupShortlists
        : [];
    },
    shortlistProperties() {
      const filters = this.studentStore.disableFilters
        ? {}
        : buildShortlistFilters({
            currentBedrooms: this.currentBedrooms,
            currentBathrooms: this.currentBathrooms,
            currentMinPrice: this.currentMinPrice,
            currentMaxPrice: this.currentMaxPrice,
            minPriceSelected: this.minPriceSelected,
            maxPriceSelected: this.maxPriceSelected,
            currentType: this.currentType,
            currentLandlord: this.currentLandlord,
            useExactRoomCounts: this.useExactRoomCounts,
          });

      return getFilteredShortlist({
        store: this.shortlistStateStore,
        filters,
      });
    },
    shortlistPropertiesCount() {
      return this.shortlistProperties.length;
    },
    paginationPropertyCount() {
      if (this.shortlistActive) {
        return this.shortlistPropertiesCount;
      }

      if (this.housemateGroupsActive) {
        return this.housemateGroupPropertiesCount;
      }

      return Number(this.propertyCount || 0);
    },
    paginationPromoOffset() {
      return 0;
    },
    computedNumberOfPages() {
      const perPage = Number(this.paginate || 0);

      if (perPage <= 0) {
        return 1;
      }

      return Math.ceil(
        (this.paginationPropertyCount + this.paginationPromoOffset) / perPage
      );
    },
    shouldHidePaginationForMapCount() {
      return (
        this.showSearchPage &&
        !this.shortlistActive &&
        !this.housemateGroupsActive &&
        !this.userEnquiriesActive &&
        this.mapCountZero
      );
    },

    shouldHideHousemateGroupSearchControls() {
      if (!this.housemateGroupsActive) {
        return false;
      }

      // "Get started" grouplist (no approved groups) + "no properties" grouplist.
      if (!this.hasApprovedHousemateGroups) {
        return true;
      }

      return this.housemateGroupPropertiesCount === 0;
    },
    isSubMenuTabActive() {
      return (
        this.shortlistActive ||
        this.housemateGroupsActive ||
        this.userEnquiriesActive
      );
    },
    showMapControls() {
      return !this.isSubMenuTabActive;
    },
    showSortControls() {
      return true;
    },
    displayedSortOptions() {
      const options =
        this.sortOptions && typeof this.sortOptions === 'object'
          ? this.sortOptions
          : {};

      if (!this.housemateGroupsActive) {
        return options;
      }

      return {
        ...options,
        upvotes: {
          full: 'Upvotes: High to Low',
          short: 'Upvotes',
        },
      };
    },
    activeSortKey() {
      if (this.shortlistActive) {
        return this.shortlistSortKey || this.currentSort || 'relevance';
      }

      if (this.housemateGroupsActive) {
        return this.grouplistSortKey || this.currentSort || 'relevance';
      }

      if (this.userEnquiriesActive) {
        return this.enquiriesSortKey || this.currentSort || 'relevance';
      }

      return this.currentSort;
    },
    displayedCurrentSortTitle() {
      const option = this.displayedSortOptions?.[this.activeSortKey];
      return option?.full || this.currentSortTitle || 'Sort by relevance';
    },
    displayedCurrentSortTitleShort() {
      const option = this.displayedSortOptions?.[this.activeSortKey];
      return option?.short || this.currentSortTitleShort || 'Relevance';
    },
    isSortDisabledOnMobile() {
      return (
        this.studentStore.isHousemateGroupManageMode ||
        this.studentStore.disableFilters
      );
    },
    activeHousemateGroupId() {
      return (
        this.studentStore.targetHousemateGroup?.housemate_group?.id ??
        this.studentStore.targetHousemateGroup?.housemate_group_id ??
        null
      );
    },
  },

  watch: {
    mapIsOpen: function (newVal) {
      if (newVal) {
        this.mapOpened();
      } else {
        this.mapClosed();
      }
    },
    reloading: function (isLoading) {
      // New filters have been applied
      if (
        isLoading &&
        !this.housemateGroupsActive &&
        !this.shortlistActive &&
        !this.userEnquiriesActive
      ) {
        this.showSearchPageResults();
      }
    },
    'studentStore.returnToSearchPage': function (newVal) {
      if (newVal) {
        this.showSearchPageResults();
      }

      this.$nextTick(() => {
        this.scrollToTop();
      });

      this.studentStore.returnToSearchPage = false;
    },
    properties: {
      immediate: true,
      handler(newProps) {
        this.localProperties = Array.isArray(newProps) ? [...newProps] : [];

        if (this.userEnquiriesActive && this.isSubMenuTabActive) {
          this.applyEnquiriesLocalSort();
        }
      },
    },
    // Set the shortlist state of each property each time we re-render the main search page.
    // We need to do this because the property cards don't persist state between re-renders.
    showSearchPage(newVal, oldVal) {
      if (newVal && !oldVal) {
        if (!this.shortlistStateStore.shortlistLoadedOnce) {
          return;
        }

        const shortlistedIds = new Set(
          (this.shortlistStateStore.shortlist || []).map((p) => String(p.id))
        );

        this.localProperties = this.localProperties.map((property) => ({
          ...property,
          shortlisted: shortlistedIds.has(String(property.id)),
        }));
      }
    },
    propertyCount: function (newVal) {
      // Keep the submenu count aligned with the currently active view.
      if (this.userEnquiriesActive) {
        this.studentStore.setMenuHeaderText('enquiries', newVal || 0);
      }
    },
    shortlistActive: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.localTabPage = 1;
      }
    },
    housemateGroupsActive: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.localTabPage = 1;
      }
    },
    computedNumberOfPages: function (newVal) {
      const totalPages = Math.max(1, Number(newVal) || 1);

      if (this.localTabPage > totalPages) {
        this.localTabPage = totalPages;
      }
    },
  },
  async mounted() {
    // Check URL for ?tab= query param to determine
    // if we should show a specific tab on page load.
    const tab = this.getTabFromUrl();

    if (!this.housemateGroupsEnabled) {
      if (tab === 'shortlist' || this.housemateGroupShowShortlistTab) {
        window.location.assign('/student/shortlist');
        return;
      }

      if (tab === 'enquiries') {
        this.setTabInUrl(null);
      }
    }

    if (!this.housemateGroupsEnabled && tab === 'grouplist') {
      this.setTabInUrl(null);
    }

    if (this.housemateGroupsEnabled && tab === 'shortlist') {
      this.toggleShortList();
    }

    if (this.housemateGroupsEnabled && tab === 'grouplist') {
      this.toggleHousemateGroup();
    }

    if (this.housemateGroupsEnabled && tab === 'enquiries') {
      this.toggleUserEnquiry();
    }

    if (this.isLoggedInStudent && this.housemateGroupsEnabled) {
      await this.studentStore.getHousemateGroups();

      // Prefetch the active grouplist in the background so switching to the
      // Grouplist tab doesn't need a visible loading state.
      try {
        this.studentStore.setTargetHousemateGroup(null, {
          updateMenuHeader: false,
        });
        const groupId =
          this.studentStore.targetHousemateGroup?.housemate_group_id;

        const alreadyLoadedForGroup =
          groupId &&
          String(this.studentStore.housemateGroupShortlistsLoadedGroupId) ===
            String(groupId);

        if (groupId && !alreadyLoadedForGroup) {
          this.studentStore
            .getHousemateGroupShortlists(groupId, { showLoading: false })
            .catch(() => null);
        }

        if (!this.studentStore.housemateGroupShortlistedByPropertyIdFetched) {
          this.studentStore
            .getHousemateGroupShortlistedPropertyIds?.()
            .catch(() => null);
        }
        // Toggle Housemate Group Tab
        if (this.studentStore.housemateGroupInviteAccepted) {
          await this.toggleHousemateGroup();
        }
      } catch (e) {
        void e;
      }
    }

    // Toggle Shortlist Tab
    if (this.housemateGroupsEnabled && this.housemateGroupShowShortlistTab) {
      this.toggleShortList();
    }

    if (this.enquiredProperties) {
      this.activateEnquiriesTabFromUrl();
    }

    if (
      this.housemateGroupsEnabled &&
      this.openHousemateGroupTab &&
      !this.housemateGroupsActive
    ) {
      this.toggleHousemateGroup();
    }

    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    // Avoid preloading the full shortlist payload on mount. For grouplist
    // entry this can add unnecessary latency; lightweight ID preload is enough
    // for heart-state checks and full shortlist data is fetched when needed.
    if (this.isLoggedInStudent) {
      this.shortlistStateStore.getShortlistedPropertyIds?.().catch((error) => {
        void error;
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);

    this.studentStore.disableFilters = false;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);

    this.studentStore.disableFilters = false;
  },
  methods: {
    getPropertyIteration(index) {
      return index + 1 - this.searchPromoOffset;
    },
    getCurrentPath,
    isGuideBanner(property) {
      return property?.id === 'guide-banner';
    },
    isSpecialListing(property) {
      return this.isGuideBanner(property);
    },
    toggleMap() {
      this.$emit('toggle-map-is-open');
    },
    setTabSortDefaults() {
      const baseSort = this.currentSort || 'relevance';

      if (this.shortlistActive && !this.shortlistSortKey) {
        this.shortlistSortKey = baseSort;
        return;
      }

      if (this.housemateGroupsActive && !this.grouplistSortKey) {
        this.grouplistSortKey = baseSort;
        return;
      }

      if (this.userEnquiriesActive && !this.enquiriesSortKey) {
        this.enquiriesSortKey = baseSort;
      }
    },
    ensureMapClosedForSubMenuTab() {
      if (!this.isSubMenuTabActive || !this.mapIsOpen) {
        return;
      }

      this.$emit('toggle-map-is-open');
    },
    getPropertyPrice(property) {
      const candidates = [
        property?.cheapestRoomPrice,
        property?.price,
        property?.cheapest_room_price,
      ];

      for (const candidate of candidates) {
        const value = Number(candidate);
        if (Number.isFinite(value)) {
          return value;
        }
      }

      return Number.MAX_SAFE_INTEGER;
    },
    applyEnquiriesLocalSort() {
      const sortKey = String(this.activeSortKey || 'relevance');

      if (
        !Array.isArray(this.localProperties) ||
        !this.localProperties.length
      ) {
        return;
      }

      if (sortKey === 'relevance') {
        this.localProperties = Array.isArray(this.properties)
          ? [...this.properties]
          : [...this.localProperties];
        return;
      }

      if (sortKey === 'price-asc') {
        this.localProperties = [...this.localProperties].sort(
          (a, b) => this.getPropertyPrice(a) - this.getPropertyPrice(b)
        );
        return;
      }

      if (sortKey === 'price-desc') {
        this.localProperties = [...this.localProperties].sort(
          (a, b) => this.getPropertyPrice(b) - this.getPropertyPrice(a)
        );
      }
    },
    handleSortChange(key) {
      if (this.isSubMenuTabActive) {
        if (this.shortlistActive) {
          this.shortlistSortKey = key;
        } else if (this.housemateGroupsActive) {
          this.grouplistSortKey = key;
        } else if (this.userEnquiriesActive) {
          this.enquiriesSortKey = key;
        }

        if (this.userEnquiriesActive) {
          this.applyEnquiriesLocalSort();
        }

        return;
      }

      this.$emit('set-current-sort', key);
    },

    setActiveTabState({
      showSearchPage,
      shortlistActive,
      housemateGroupsActive,
      userEnquiriesActive,
    }) {
      if (typeof showSearchPage === 'boolean') {
        this.showSearchPage = showSearchPage;
      }

      if (typeof shortlistActive === 'boolean') {
        this.shortlistActive = shortlistActive;
      }

      if (typeof housemateGroupsActive === 'boolean') {
        this.housemateGroupsActive = housemateGroupsActive;
      }

      if (typeof userEnquiriesActive === 'boolean') {
        this.userEnquiriesActive = userEnquiriesActive;
      }
    },

    cancelIfStale(toggleCounter) {
      return (
        toggleCounter !== this.housemateGroupToggleCounter ||
        !this.housemateGroupsActive
      );
    },

    enterGrouplistTab() {
      // Ensure the active-tab state is mutually exclusive immediately.
      // This avoids scenarios where the grouplist opens but an early return
      // i.e. no groups available or async load leaves another tab active.
      this.setActiveTabState({
        housemateGroupsActive: true,
        showSearchPage: false,
        shortlistActive: false,
        userEnquiriesActive: false,
      });

      this.studentStore.showSearchSubMenu = true;
      // Show the grouplist view immediately; it will render skeleton/empty
      // states based on the store while we fetch in the background.
      this.studentStore.showHousemateGroupDetail = true;

      // Disable immediately while the grouplist context loads so the UI state
      // changes in sync with the tab change.
      this.studentStore.disableFilters = true;

      // Set a safe initial header state (count 0) while we load groups/shortlists.
      this.studentStore.setMenuHeaderText('grouplist');
      this.grouplistTabLoading = true;
      this.setTabSortDefaults();
      this.ensureMapClosedForSubMenuTab();
    },

    exitGrouplistTab() {
      this.setActiveTabState({
        housemateGroupsActive: false,
        showSearchPage: true,
      });

      this.studentStore.showSearchSubMenu = false;
      this.studentStore.showHousemateGroupDetail = false;
      this.studentStore.disableFilters = false;
      this.grouplistTabLoading = false;
      // If the user was previously viewing enquiries, ensure we return to
      // their last search results when closing this tab.
      this.$emit('set-enquired-properties', false);
    },

    setGrouplistNoGroupsState() {
      // "Get started" grouplist state (no approved groups).
      this.studentStore.setMenuHeaderText('grouplist');
      this.studentStore.showSearchSubMenu = true;
      this.studentStore.showHousemateGroupDetail = false;
      this.studentStore.disableFilters = true;
      this.grouplistTabLoading = false;
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleScroll() {
      if (
        (!this.isMobile && !this.isTablet) ||
        this.mapIsOpen ||
        this.propertyCount <= 0 ||
        this.showMobilePropertyTypeFiltersOnlyMode
      ) {
        this.showStickyButton = false;
        return;
      }
      this.showStickyButton = true;

      // hide sticky button if at the top of the page and slide it up as user scrolls down
      const stickyButton = this.$refs.mapViewStickyButton;

      if (stickyButton) {
        const stickyButtonRect = stickyButton.getBoundingClientRect();
        const distanceFromTop = window.scrollY;
        const slideThreshold = stickyButtonRect.height + 18; // distance from the bottom including 18px margin (tw-mb-4)

        // Fade in as it slides up into view from top
        const baseOpacity = Math.max(
          0,
          Math.min(1, distanceFromTop / Math.max(1, slideThreshold))
        );

        if (distanceFromTop < slideThreshold) {
          stickyButton.style.bottom = distanceFromTop - slideThreshold + 'px';
        } else {
          stickyButton.style.bottom =
            stickyButtonRect.height !== 0 ? 0 : stickyButton.style.bottom;
        }

        // hide sticky button if user scrolls past the search results/list container
        // Use permanent fixture - list container always exists
        const listContainer = this.$refs.listContainer;
        let containerDistanceFromTop = 0;

        if (listContainer) {
          const rect = listContainer.getBoundingClientRect();
          // Use bottom of container as boundary
          containerDistanceFromTop = rect.bottom;
        }

        let fadeOutOpacity = 1;
        if (containerDistanceFromTop <= window.innerHeight) {
          fadeOutOpacity = Math.max(
            0,
            Math.min(1, containerDistanceFromTop - window.innerHeight)
          );
        }

        stickyButton.style.opacity = Math.max(
          0,
          Math.min(1, Math.min(baseOpacity, fadeOutOpacity))
        );

        this.showStickyButton = containerDistanceFromTop > window.innerHeight;
      }
    },
    activateEnquiriesTabFromUrl() {
      if (!this.isLoggedInStudent || !this.hasEnquiredProperties) {
        this.userEnquiriesActive = false;
        this.studentStore.showSearchSubMenu = false;
        return;
      }

      this.userEnquiriesActive = true;
      this.shortlistActive = false;
      this.housemateGroupsActive = false;
      this.showSearchPage = this.isLoggedInStudent ? true : false;

      this.studentStore.showSearchSubMenu = true;
      // When landing directly on enquiries (via URL), propertyCount is the
      // enquiries count. Otherwise fall back to the store's cached count.
      this.studentStore.setMenuHeaderText(
        'enquiries',
        typeof this.propertyCount === 'number'
          ? this.propertyCount
          : this.studentStore.enquiriesPropertyCount || 0
      );
      this.studentStore.disableFilters = true;
      this.studentStore.showHousemateGroupDetail = false;
      this.setTabSortDefaults();
      this.ensureMapClosedForSubMenuTab();
    },
    shouldShowInfoDiv(index, currentPage) {
      const isMobile = this.windowWidth < 768;

      if (currentPage % 2 === 0) {
        return false;
      }
      if (this.enableUpdatedPropertyTile) {
        return index === this.infoDivIndex;
      }

      // Only show once on the first page
      if (currentPage === 1) {
        if (isMobile) {
          return index === 0;
        } else return index === 5;
      } else {
        if (isMobile) {
          return index === 4;
        }
        return index === 5;
      }
    },
    handlePagination(page) {
      this.currentPage = page;

      if (this.shortlistActive || this.housemateGroupsActive) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    mapOpened() {
      // Prevent body scrolling when map is open
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    },
    mapClosed() {
      // Restore body scrolling when map is closed
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    },
    pluralise(string, number, boolean) {
      return Pluralize(string, number, boolean);
    },
    ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async handleHousemateGroupVote({ propertyId, vote } = {}) {
      const housemateGroupId = this.activeHousemateGroupId;

      if (!housemateGroupId || !propertyId || !['yes', 'no'].includes(vote)) {
        return;
      }

      const payload =
        await this.studentStore.voteHousemateGroupShortlistProperty({
          housemateGroupId,
          propertyId,
          vote,
        });

      if (!payload || payload.success !== true) {
        return;
      }

      const targetPropertyIds = new Set([
        String(propertyId),
        String(payload.property_id ?? ''),
      ]);

      this.localProperties = this.localProperties.map((property) => {
        const candidateIds = [
          String(property?.id ?? ''),
          String(property?.propertyId ?? ''),
          String(property?.property_id ?? ''),
        ];

        const isTargetProperty = candidateIds.some((candidateId) =>
          targetPropertyIds.has(candidateId)
        );

        if (!isTargetProperty) {
          return property;
        }

        return {
          ...property,
          groupVote:
            typeof payload.vote === 'string'
              ? payload.vote.toLowerCase()
              : null,
          groupVoteYesCount: Number(payload.group_vote_yes_count ?? 0),
          groupVoteNoCount: Number(payload.group_vote_no_count ?? 0),
          groupVoteHasNo: Boolean(payload.group_vote_has_no ?? false),
        };
      });

      if (String(this.activeSortKey || 'relevance') === 'upvotes') {
        this.localProperties =
          this.studentStore.sortHousemateGroupPropertiesByVotes(
            this.localProperties
          );
        return;
      }

      this.applyEnquiriesLocalSort();
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async toggleHousemateGroup() {
      if (!this.housemateGroupsEnabled) {
        return;
      }

      const toggleCounter = ++this.housemateGroupToggleCounter;
      const isActivating = !this.housemateGroupsActive;

      if (isActivating) {
        this.setTabInUrl('grouplist');
      } else {
        this.setTabInUrl(null);
      }

      this.$nextTick(() => {
        this.scrollToTop();
      });

      if (!isActivating) {
        this.exitGrouplistTab();
        return;
      }

      this.enterGrouplistTab();
      try {
        // Ensure housemate groups are loaded before deciding which view/header to show.
        if (this.isLoggedInStudent) {
          await this.studentStore.getHousemateGroups();

          if (this.cancelIfStale(toggleCounter)) {
            return;
          }
        }

        const hasGroups = this.studentStore.hasApprovedHousemateGroups;

        if (!hasGroups) {
          this.setGrouplistNoGroupsState();
          return;
        }
        if (hasGroups) {
          this.studentStore.setTargetHousemateGroup();

          const groupId =
            this.studentStore.targetHousemateGroup?.housemate_group_id;

          if (groupId) {
            // Always refresh when entering the grouplist tab so the view matches
            // the server state (same behavior expectation as enquiries/shortlist).
            await this.studentStore.getHousemateGroupShortlists(groupId, {
              showLoading: true,
            });

            if (this.cancelIfStale(toggleCounter)) {
              return;
            }

            const count = Number.isFinite(
              this.studentStore.housemateGroupShortlistCount
            )
              ? this.studentStore.housemateGroupShortlistCount
              : Array.isArray(this.studentStore.housemateGroupShortlists)
              ? this.studentStore.housemateGroupShortlists.length
              : 0;

            this.studentStore.setMenuHeaderText(
              this.studentStore.targetHousemateGroup?.housemate_group_name,
              count
            );

            // Filters/search are always disabled on the grouplist tab.
            this.studentStore.disableFilters = true;
          }
        }
      } finally {
        if (
          this.housemateGroupsActive &&
          toggleCounter === this.housemateGroupToggleCounter
        ) {
          this.grouplistTabLoading = false;
        }
      }
    },
    toggleShortList() {
      if (!this.housemateGroupsEnabled) {
        window.location.assign('/student/shortlist');
        return;
      }

      const isActive = !this.shortlistActive;

      if (isActive) {
        this.setTabInUrl('shortlist');
      } else {
        this.setTabInUrl(null);
      }

      this.shortlistActive = isActive;
      this.showSearchPage = !isActive;
      this.studentStore.showSearchSubMenu = isActive;

      if (isActive) {
        this.studentStore.setMenuHeaderText('shortlist');
        this.studentStore.disableFilters = true;
        this.studentStore.showHousemateGroupDetail = false;
        this.housemateGroupsActive = false;
        this.userEnquiriesActive = false;
        this.setTabSortDefaults();
        this.ensureMapClosedForSubMenuTab();

        // scroll to top on select, after waiting for Vue to render the shortlist
        this.$nextTick(() => {
          this.scrollToTop();
        });

        return;
      }

      this.studentStore.showSearchSubMenu = false;
      this.studentStore.disableFilters = false;
      // If the user was previously viewing enquiries, ensure we return to
      // their last search results when closing this tab.

      // scroll back up when returning to search results
      this.$nextTick(() => {
        this.scrollToTop();
      });

      this.$emit('set-enquired-properties', false);
    },
    toggleUserEnquiry() {
      if (!this.housemateGroupsEnabled) {
        return;
      }

      const isActive = !this.userEnquiriesActive;

      if (isActive) {
        this.setTabInUrl('enquiries');
      } else {
        this.setTabInUrl(null);
      }

      this.$nextTick(() => {
        this.scrollToTop();
      });

      this.userEnquiriesActive = isActive;
      this.showSearchPage = this.isLoggedInStudent ? true : !isActive;
      this.studentStore.showSearchSubMenu = isActive;

      if (isActive) {
        // Never seed the enquiries header with the *search* count.
        // Use the store's cached enquiries count (0 until first load), then
        // let the propertyCount watcher update it once enquiries load.
        const cachedEnquiriesCount =
          typeof this.studentStore.enquiriesPropertyCount === 'number'
            ? this.studentStore.enquiriesPropertyCount
            : 0;

        this.studentStore.setMenuHeaderText('enquiries', cachedEnquiriesCount);
        this.studentStore.disableFilters = true;
        this.studentStore.showHousemateGroupDetail = false;
        this.housemateGroupsActive = false;
        this.shortlistActive = false;
        this.setTabSortDefaults();
        this.ensureMapClosedForSubMenuTab();

        if (this.isLoggedInStudent) {
          this.$emit('set-enquired-properties', true);
        }

        return;
      }

      this.studentStore.showSearchSubMenu = false;
      this.studentStore.disableFilters = false;
      this.$emit('set-enquired-properties', false);
    },
    showSearchPageResults() {
      // Cancel any in-flight grouplist toggle work so it can't re-disable filters
      // after we've returned to the main search UI.
      this.housemateGroupToggleCounter += 1;

      this.showSearchPage = true;
      this.userEnquiriesActive = false;
      this.housemateGroupsActive = false;
      this.shortlistActive = false;
      this.studentStore.showHousemateGroupDetail = false;
      this.studentStore.disableFilters = false;
      this.grouplistTabLoading = false;

      this.setTabInUrl(null);

      this.$emit('set-enquired-properties', false);

      this.studentStore.handleReturnToSearchPage();
    },
    getTabFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.get('tab');
    },
    setTabInUrl(tab) {
      const url = new URL(window.location);

      if (tab) {
        url.searchParams.set('tab', tab);
      } else {
        url.searchParams.delete('tab');
      }

      window.history.replaceState({}, '', url);
    },
  },
};
</script>
